<template>
    <div class="container">
        <div class="col-sm-3 col-xs-2"></div>
        <div class="col-sm-6 col-xs-8">
            <div class="row">
                <div class="col-sm-3 col-xs-0"></div>
                <div class="col-sm-6 col-xs-12">
                    <div class="form-group has-feedback has-feedback-left">
                        <input type="text" class="form-control" v-model="name" name="name" maxlength="150" placeholder="Account Name"  />
                    </div>
                </div>
                <div class="col-sm-3 col-xs-0"></div>
            </div>
            <br>
            <div class="row">
                <div class="col-sm-3 col-xs-0"></div>
                <div class="col-sm-6 col-xs-12">
                    <div class="form-group has-feedback has-feedback-left">
                        <input type="text" class="form-control" v-model="email" name="email" maxlength="120" placeholder="Email Address"  />
                    </div>
                </div>
                <div class="col-sm-3 col-xs-0"></div>
            </div>
            <br>
            <div class="row">
                <div class="col-sm-3 col-xs-0"></div>
                <div class="col-sm-6 col-xs-12">
                    <div class="form-group has-feedback">
                        <input type="password" class="form-control" placeholder="Password" maxlength="32" v-model="password" name="password"/>
                    </div>
                </div>
                <div class="col-sm-3 col-xs-0"></div>
            </div>
            <br>
            <div class="row">
                <div class="col-sm-3 col-xs-0"></div>
                <div class="col-sm-6 col-xs-12">
                    <div class="form-group has-feedback">
                        <input type="password" class="form-control" placeholder="Verify Password" maxlength="32" v-model="verifyPassword" name="verifyPassword" />
                    </div>
                </div>
                <div class="col-sm-3 col-xs-0"></div>
            </div>
            <br>
            <div class="row">
                <div class="col-xs-12"><button class="btn btn-primary" @click="updateAccount">Update Account</button></div>
            </div>
        </div>
        <div class="col-sm-3 col-xs-2"></div>
    </div>
</template>

<script>
  export default {
    name: 'company-management-page',
    data () {
      return {
        username: '',
        password: '',
        email: '',
        name: '',
        userType: '',
        userStatus: ''
      }
    }
  }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/companyManagementPage.vue